import {PropertyBase} from "./PropertyBase";

export class LinkProperty extends PropertyBase{
    public label:string="Label";
    public callBack:()=>void;
    public text:string;

    protected InternalGetElement(): JQuery {
        let $element=jQuery('<a href="#">'+this.text+'</a>');
        $element.click(e=>{e.preventDefault();this.callBack()});
        return $element;
    }

    public SetText(text:string){
        this.text=text;
        return this;
    }

    public SetOnClick(callBack:()=>void)
    {
        this.callBack=callBack;
        return this;
    }


    protected InternalGenerationCompleted($element: JQuery) {
    }

    public SubRenderer(): React.ReactNode {
        return undefined;
    }

}